<template>
    <crud-list :data-list="outlets">
      <template v-slot:listItem="{ listItem }">
        {{ listItem.name }}
      </template>
      <template  v-slot="{ form: item }">
        <form-outlet :toCopy="item.item" :operation="item.operation"/>
      </template>
    </crud-list>
</template>

<script>
import {mapState, mapActions} from "vuex";
import CrudList from "@/core/components/CrudList";
import FormOutlet from "@/modules/outlets/components/FormOutlet";

export default {
  name: 'Outlet',
  components:{
    CrudList,
    FormOutlet
  },
  computed:{
    ...mapState('outlets',['outlets'])
  },
  created() {
    this.loadOutlets()
  },
  updated() {
    this.loadList(this.outlets)
  },
  methods: {
    ...mapActions('outlets', ['loadOutlets']),
    ...mapActions('crudList',['loadList'])
  },
}
</script>

<style scoped>
</style>
